<app-modal-header
  [title]="data?.service?.serviceName || (service$ | async)?.serviceName"
  (closeModal)="closeModal($event)">
</app-modal-header>

<div class="flex">
  <div class="p-2 bg-secondary-50/50 border-1 border-secondary-100 flex flex-wrap gap-2 rounded-lg">
    <span>{{ 'View more service details' | concat | translate }}</span>
    <span
      (click)="openServiceDetails()"
      class="underline cursor-pointer font-black animate-pulse !text-secondary-500">
      {{ 'Click Here' | concat | translate }}
    </span>
  </div>
</div>
<mat-dialog-content class="!p-0">
  <div *ngIf="service$ | async as service"
       class="flex flex-col md:flex-row justify-start items-start gap-4 min-w-0">
    <div class="w-full md:w-8/12 min-w-0">
      <div class="border-b border-primary-500">
        <app-portal-title-bar [hideBackButton]="true" [title]="service?.serviceName"></app-portal-title-bar>
      </div>

      <p class="intro-x mt-2">{{ service?.serviceDescription }}</p>

      <h3 class="text-primary-500 text-md py-2 intro-x" style="font-weight: bold">
        {{ "Mahitaji ya Kupata Huduma"|concat|translate }}
      </h3>

      <div class="overflow-x-auto">
      <table class="w-full intro-x table-fixed">
        <thead class="bg-primary-500 text-secondary-500">
        <tr style="height: 40px">
          <th class="col-md-1">
            <span class="mx-2 py-1">{{ "Hatua"|concat|translate }}</span>
          </th>
          <th class="col-md-6">
            <span class="mx-2 py-1">{{ "mahitaji ya kupata huduma"|concat|translate }}</span>
          </th>
          <th class="col-md-5">
            <span class="mx-2 py-1">{{ "Uhitaji"|concat|translate }}</span>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
          *ngFor="let requirement of requirements$ | async; let i = index"
          class="intro-x bg-light_primary"
          style="height: 30px">
          <td class="border border-primary-500">
            <span class="mx-2">{{ i + 1 }}.</span>
          </td>
          <td class="border p-2 border-primary-500 flex flex-col break-words min-w-0">
            <span>{{ requirement?.requirement?.requirementName }}</span>
            <span class="text-xs text-gray-400">{{ requirement?.requirement?.descriptions }}</span>
            @if (requirement?.requirement?.modAlternativesRequirements?.length) {
              <span class="text-xs">
                <span class="text-primary-500">
                  {{ 'Alternative Requirements' | concat | translate }}:
                </span>
                {{ requirement?.requirement?.modAlternativesRequirements }}
              </span>
            }
          </td>
          <td class="border p-2 border-primary-500">
            <span
              *ngIf="requirement?.requirementIsMandatory; else notNecessary"
              class="text-red-600">{{ "mandatory" | translate }}</span>
            <ng-template #notNecessary>
              <span>{{ "not_mandatory" | translate }}</span>
            </ng-template>
          </td>
        </tr>
        </tbody>
      </table>
      </div>

      <div class="grid md:grid-cols-3 grid-cols-1 gap-2 mt-3 justify-between min-w-0">
        <div class="w-full intro-x col-span-1 min-w-0">
          <div class="text-primary-500 text-md py-2">
            <div class="py-1">{{ "Wanafaika wahuduma"|concat|translate }}</div>
            <div class="w-6/12 h-[2px] mt-1 mb-2 bg-secondary-500"></div>
          </div>
          <div *ngFor="let group of service?.serviceGroups; let i = index">
            <span class="font-semibold">{{ i + 1 }}.</span>
            <span *ngIf="group?.groupType == 'G2G'" class="mx-2">{{ "government" | translate }}</span>
            <span *ngIf="group?.groupType == 'G2C'" class="mx-2">{{ "citizen" | translate }}</span>
            <span *ngIf="group?.groupType == 'G2B'" class="mx-2">{{ "business" | translate }}</span>
            <span *ngIf="group?.groupType == 'G2E'" class="mx-2">{{ "employee" | translate }}</span>
            <span *ngIf="group?.groupType == 'G2F'" class="mx-2">{{ "foreigner" | translate }}</span>
          </div>
        </div>

        <div class="w-full intro-x col-span-1 min-w-0">
          <div class="text-primary-500 text-md py-2">
            <div class="py-1">{{ "Njia za kupata huduma kwa kupitia mtandao"|concat|translate }}</div>
            <div class="w-6/12 h-[2px] mt-1 mb-2 bg-secondary-500"></div>
          </div>
          <div *ngFor="let automation of servicesAutomations$ | async">
            <div *ngIf="automation.serviceIsAutomated">
              <div *ngFor="let provision of automation?.serviceProvisions; let i = index">
                <div
                  *ngIf="provision?.serviceProvisionMeans === 'Web'"
                  class="p-2 px-3 mb-3 flex flex-col bg-white shadow-sm rounded-2xl min-w-0 overflow-hidden">
                  <p class="text-primary-500" style="font-weight: bold">
                    {{ "Mfumo wa Tovuti"|concat|translate }}
                  </p>
                  <p class="break-words">{{ provision?.serviceSystemName }}</p>
                  <a class="break-all" [href]="provision?.serviceReachLink" target="_blank">{{ provision?.serviceReachLink }}</a>
                </div>
                <div
                  *ngIf="provision?.serviceProvisionMeans == 'MobileApp'"
                  class="p-2 mb-3 flex flex-col bg-white shadow-sm rounded-2xl min-w-0 overflow-hidden">
                  <p class="text-primary-500" style="font-weight: bold">
                    {{ "Aplikesheni ya Simu"|concat|translate }}
                  </p>
                  <p class="break-words">{{ provision?.serviceSystemName }}</p>
                  <a class="break-all" [href]="provision?.serviceReachLink" target="_blank">{{ provision?.serviceReachLink }}</a>
                </div>
                <div
                  *ngIf="provision?.serviceProvisionMeans == 'USSD'"
                  class="p-2 mb-3 flex flex-col bg-white shadow-sm rounded-2xl min-w-0 overflow-hidden">
                  <p class="text-primary-500" style="font-weight: bold">{{ "mSIMBO"|concat|translate }}</p>
                  <p class="break-words">{{ provision?.serviceSystemName }}</p>
                  <p class="break-all">{{ provision?.serviceReachLink }}</p>
                </div>
                <div
                  *ngIf="provision?.serviceProvisionMeans == 'SMS'"
                  class="p-2 mb-3 flex flex-col bg-white shadow-sm rounded-2xl min-w-0 overflow-hidden">
                  <p class="text-primary-500" style="font-weight: bold">{{ "Jumbe fupi"|concat|translate }}</p>
                  <p class="break-words">{{ provision?.serviceSystemName }}</p>
                  <p class="break-all">{{ provision?.serviceReachLink }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-span-1 min-w-0">
          <div class="text-primary-500 text-md py-2">
            <div class="py-1">{{ "Pakupokea majibu ya huduma"|concat|translate }}</div>
            <div class="w-6/12 h-[2px] mt-1 mb-2 bg-secondary-500"></div>
          </div>
          <div class="text-sm" *ngFor="let channel of deliveryChannels$ | async; let i = index">
            <div *ngIf="channel?.channelName == 'PHYSICAL_DELIVERY'">
              <span>{{ "Majibu ya huduma yatatolewa kwa njia ya Kuletewa ulipo"|concat|translate }}</span>
            </div>
            <div *ngIf="channel?.channelName == 'WALK_IN'">
              <span>{{ "Majibu ya huduma yatatolewa kwa njia ya Ofsini"|concat|translate }}</span>
            </div>
            <div *ngIf="channel?.channelName == 'ONLINE'">
              <span>{{ "Majibu ya huduma yatatolewa kwa njia ya Online"|concat|translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full flex flex-col gap-3 md:w-4/12 intro-x min-w-0">
      <div class="bg-light_primary rounded-md">
        <div class="px-3 py-5 flex flex-col md:flex-row items-center gap-3 min-w-0" *ngIf="service?.serviceProvider as provider">
          <div class="p-2 shrink-0">
            @if (provider?.institutionLogo) {
              <img
                [src]="fileServer + provider?.institutionLogo"
                class="rounded h-20 w-20 shrink-0 object-contain"
                alt="Institution Logo"/>
            } @else {
              <img src="/assets/images/emblem.png"
                   alt="Institution Logo"
                   class="h-10 lg:h-20 md:h-20 sm:h-14 cursor-pointer self-baseline"/>
            }
          </div>

          <div class="intro-x min-w-0">
            <div class="text-primary-500 text-lg">{{ provider?.institutionName | titlecase }}</div>
            <div class="flex flex-col gap-1 mt-2 break-words">
              <p>
                <b class="mr-2">{{ "Wizara"|concat|translate }}:</b>
                {{ provider?.institutionMinistry?.ministryName }}
              </p>
              <p>
                <b class="mr-2">{{ "service_sectors" | translate }}:</b>
                {{ provider?.institutionSector?.sectorName }}
              </p>
              <p class="break-all">
                <b class="mr-2">{{ "Anuani"|concat|translate }}:</b>
                {{ provider?.institutionEmail }}
              </p>
              <p class="break-all">
                <b class="mr-2">{{ "Tovuti"|concat|translate }}:</b>
                {{ provider?.institutionWebsite }}
              </p>
              <div class="col-span-2 text-md flex items-center justify-center rounded-lg bg-primary-500/80 text-white py-2 px-2">
                <span class="font-semibold text-md">{{ "Wasifu wa taasisi"|concat|translate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-light_primary px-3 md:px-5 py-4 flex gap-3 rounded-md">
        <div class="flex flex-col gap-2 flex-grow">
          <div class="text-gray-700 font-bold text-lg">{{ "Je Unahitaji msaada ?"|concat|translate }}</div>
          <div class="text-gray-700 text-md pb-1">
            {{ "Unaweza kutufikia kwa kupiga simu ama kutuma ujumbe mfupi kupitia "|concat|translate }}:
          </div>
          <div class="text-gray-700 border-b mt-2 text-lg border-secondary-400">
            {{ "Social Medias"|concat|translate }}
          </div>
          <div class="flex flex-wrap gap-3 mt-2">
            @for (x of socialMediaLinks; track x) {
              <div class="text-primary-400">
                <mat-icon [svgIcon]="x?.icon"></mat-icon>
              </div>
            }
            <div class="text-primary-400 flex">
              <span>govservicesportal</span>
              <mat-icon class="scale-50 align-top">north_east</mat-icon>
            </div>
          </div>
          <div class="grid grid-cols-2 mt-3 gap-1">
            <div class="col-span-1 text-md flex items-center justify-center rounded-lg bg-primary-500/80 text-white py-1 px-2">
              <mat-icon class="text-secondary-500 align-middle scale-75" svgIcon="message"></mat-icon>
              <span class="font-semibold text-md">{{ "Tuma ujumbe"|concat|translate }}</span>
            </div>
            <div class="col-span-1 text-md flex items-center justify-center rounded-lg bg-primary-500/80 text-white py-1 px-2">
              <mat-icon class="text-secondary-500 align-middle scale-75" svgIcon="phone-call"></mat-icon>
              <span class="font-semibold text-md">{{ "Piga simu"|concat|translate }}</span>
            </div>
            <div class="col-span-2 text-md flex items-center justify-center rounded-lg bg-primary-500/80 text-white py-1 px-2">
              <mat-icon class="text-secondary-500 align-middle scale-75" svgIcon="msaadaAi"></mat-icon>
              <span class="font-semibold text-md">{{ "Msaada Ai"|concat|translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
